import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResumeDataByID } from '@edtech-ui/core/models/resume-builder/get-resume-by-id';

@Component({
  selector: 'app-executive-template',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './executive-template.component.html',
  styleUrl: './executive-template.component.scss'
})
export class ExecutiveTemplateComponent {
  @Input() data!: ResumeDataByID;
  @Input() color: string = '#4f46e5';
  @Input() font: string = 'Inter'

}
